import { ReportsSchoolSearchResultsGuard } from './reports-school-searchresults.guard'

export const guards: any[] = [
  ReportsSchoolSearchResultsGuard,
];

export * from './reports-school-searchresults.guard';
